import React from "react";
import MultiSelectDropdown from "../../select/base/MultiSelectDropdown";

const ageRangesOptions = [
  { value: "RANGE_18_25", label: "app.report.ageRange.18_25" },
  { value: "RANGE_26_35", label: "app.report.ageRange.26_35" },
  { value: "RANGE_36_45", label: "app.report.ageRange.36_45" },
  { value: "RANGE_46_55", label: "app.report.ageRange.46_55" },
  { value: "RANGE_56_65", label: "app.report.ageRange.56_65" },
  { value: "RANGE_66_PLUS", label: "app.report.ageRange.66_plus" },
  { value: "UNDEFINED", label: "app.notAvailable" },
];

const SelectAgeRanges = ({ setSelectedAgeRanges }) => {
  return (
    <MultiSelectDropdown
      title="app.report.ageRange"
      values={ageRangesOptions}
      onChange={setSelectedAgeRanges}
    />
  );
};

export default React.memo(SelectAgeRanges);
